<template>
  <form-item
    :label="label"
    :validator="validator"
    class="w-full">
    <el-input
      v-model="val"
      type="textarea"
      style="height: auto;"
      :rows="rows"
      :disabled="disabled"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :show-word-limit="!!maxlength"
      :resize="resize"
      autosize
      @blur="$emit('blur')" />
  </form-item>
</template>

<script>
import inputMixin from './input-mixin.js'

export default {
  mixins: [inputMixin],

  props: {
    rows: {
      type: Number,
      default: 3
    },

    maxlength: {
      type: [Number, String],
      default: null
    },

    resize: {
      type: String,
      default: 'none'
    }
  }
}
</script>
